"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Icon_1 = __importDefault(require("./Icon"));
var formatTime_1 = require("../utils/formatTime");
var VideoPlayerThumbnail = function (_a) {
    var source = _a.source, className = _a.className, onClick = _a.onClick, disabled = _a.disabled;
    var videoRef = react_1.default.useRef(null);
    var _b = __read(react_1.default.useState(0), 2), duration = _b[0], setDuration = _b[1];
    var sourceWithTime = source + (source.includes('?') ? '&' : '?') + 't=5';
    (0, react_1.useEffect)(function () {
        var _a;
        var durationChangeHandler = function () {
            var _a;
            setDuration(((_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.duration) || 0);
        };
        (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener("durationchange", durationChangeHandler);
        return function () {
            var _a;
            (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener("durationchange", durationChangeHandler);
        };
    }, []);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('ui-theme ui-video-player-thumbnail', disabled && 'disabled', className), onClick: disabled ? undefined : onClick },
        !disabled && (react_1.default.createElement(Icon_1.default, { icon: "play_arrow", fill: true, className: "ui-video-player-thumbnail-play", size: "xxlarge" })),
        react_1.default.createElement("video", { ref: videoRef, src: sourceWithTime }),
        react_1.default.createElement("span", { className: "ui-video-player-thumbnail-time" }, duration > 0 ? (0, formatTime_1.formatTime)(duration * 1000) : '')));
};
exports.default = VideoPlayerThumbnail;
